import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  blueprintsApi,
  type CreateBlueprintPayload,
  type Blueprint,
} from "@/services/blueprints-service";
import { BLUEPRINTS_QUERY_KEY } from "./useBlueprintsTableData";

import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

export const useSaveBlueprint = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation<
    Blueprint,
    Error,
    { id?: string; payload: CreateBlueprintPayload; files?: File[] }
  >({
    mutationFn: ({ id, payload, files }) =>
      id
        ? blueprintsApi.updateBlueprint(id, payload)
        : blueprintsApi.createBlueprint(payload, files),
    onSuccess: async (data, { id }) => {
      if (id) {
        queryClient.setQueryData(["blueprint", id], data);
        queryClient.setQueryData(["playground-blueprint", id], data);
      }
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: BLUEPRINTS_QUERY_KEY }),
        queryClient.invalidateQueries({ queryKey: ["blueprint-select"] }),
      ]);
      id
        ? toast.success(t("blueprints.blueprintUpdatedSuccessfully"))
        : toast.success(t("blueprints.blueprintCreatedSuccessfully"));
    },
    onError: (error) => {
      // toast.error(`Failed to save blueprint: ${error.message}`);m
    },
  });
};

export const useDeleteBlueprint = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation<void, Error, string>({
    mutationFn: (id) => blueprintsApi.deleteBlueprint(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: BLUEPRINTS_QUERY_KEY });
      toast.success(t("blueprints.blueprintDeletedSuccessfully"));
    },
    onError: (error) => {
      toast.error(`Failed to delete blueprint: ${error.message}`);
    },
  });
};
